import Logo from '@/assets/logo-averix-dark.svg';

export function FormLogo() {
  return (
    <div className="flex flex-col items-center mb-8">
      <img src={Logo} className="h-24 object-contain" alt="Averix" />
    </div>
  );
}
